import * as React from 'react';
import { ETargetPage, MainFiltersWidget } from '@cian/valuation-main-filters-widget';
import { useSelector } from 'react-redux';

import { selectIsCalculatorPage, selectIsWebview } from '../../selectors/page';

export const MainFiltersWidgetContainer: React.FC = () => {
  const isCalculatorPage = useSelector(selectIsCalculatorPage);
  const isWebview = useSelector(selectIsWebview);

  return (
    <MainFiltersWidget
      isWebview={isWebview}
      targetPage={isCalculatorPage ? ETargetPage.valuationForAgentCalculatorPage : ETargetPage.valuationAgentResults}
    />
  );
};

MainFiltersWidgetContainer.displayName = 'MainFiltersWidgetContainer';
